/** authContact strings for pa, te, ta, mr, bn, kn (en/hi live in translations.js). */

const AUTH_CONTACT = {
  pa: {
    verifyEmailAddress: "ਈਮੇਲ ਪਤਾ ਪੁਸ਼ਟੀ ਕਰੋ",
    verifyPhoneNumber: "ਫੋਨ ਨੰਬਰ ਪੁਸ਼ਟੀ ਕਰੋ",
    enterDetailsForOtp: "OTP ਪ੍ਰਾਪਤ ਕਰਨ ਲਈ ਆਪਣਾ ਵਿਵਰਣ ਦਾਖਲ ਕਰੋ",
    enterMobileForOtp: "OTP ਪ੍ਰਾਪਤ ਕਰਨ ਲਈ ਆਪਣਾ ਮੋਬਾਈਲ ਨੰਬਰ ਦਾਖਲ ਕਰੋ",
    emailPlaceholder: "you@gmail.com",
    fullName: "ਪੂਰਾ ਨਾਮ",
    enter10DigitNumber: "10 ਅੰਕਾਂ ਦਾ ਨੰਬਰ ਦਾਖਲ ਕਰੋ",
    emailConfirmHint: "ਅਸੀਂ ਤੁਹਾਡੇ ਈਮੇਲ ਪਤੇ ਦੀ ਪੁਸ਼ਟੀ ਲਈ ਕੋਡ ਭੇਜਾਂਗੇ।",
    phoneConfirmHint: "ਅਸੀਂ ਤੁਹਾਡੇ ਫੋਨ ਨੰਬਰ ਦੀ ਪੁਸ਼ਟੀ ਲਈ ਕੋਡ ਭੇਜਾਂਗੇ।",
    serviceMessagesHint: "ਅਸੀਂ ਕਦੇ-ਕਦਾਈਂ ਸੇਵਾ ਸੰਬੰਧੀ ਸੁਨੇਹੇ ਭੇਜ ਸਕਦੇ ਹਾਂ।",
    next: "ਅੱਗੇ",
    send: "ਭੇਜੋ",
    enterSecurityCode: "ਸੁਰੱਖਿਆ ਕੋਡ ਦਾਖਲ ਕਰੋ",
    codeSentTo: "ਕੋਡ ਭੇਜਿਆ ਗਿਆ",
    didntReceiveCode: "ਕੋਡ ਨਹੀਂ ਮਿਲਿਆ?",
    resendIn: "ਦੁਬਾਰਾ ਭੇਜੋ",
    resendCode: "ਕੋਡ ਦੁਬਾਰਾ ਭੇਜੋ",
    resendNow: "ਹੁਣੇ ਦੁਬਾਰਾ ਭੇਜੋ",
    clear: "ਸਾਫ਼ ਕਰੋ",
    close: "ਬੰਦ ਕਰੋ",
    invalidEmailFormat: "ਕਿਰਪਾ ਕਰਕੇ ਮਾਨ્ય ਈਮੇਲ ਪਤਾ ਦਾਖਲ ਕਰੋ (ਉਦਾ., name@domain.com)",
  },
  te: {
    verifyEmailAddress: "ఇమెయిల్ చిరునామా ధృవీకరించండి",
    verifyPhoneNumber: "ఫోన్ నంబర్ ధృవీకరించండి",
    enterDetailsForOtp: "OTP పొందడానికి మీ వివరాలను నమోదు చేయండి",
    enterMobileForOtp: "OTP పొందడానికి మీ మొబైల్ నంబర్ నమోదు చేయండి",
    emailPlaceholder: "you@gmail.com",
    fullName: "పూర్తి పేరు",
    enter10DigitNumber: "10 అంకెల నంబర్ నమోదు చేయండి",
    emailConfirmHint: "మీ ఇమెయిల్ చిరునామాను నిర్ధారించడానికి మేము కోడ్ పంపుతాము.",
    phoneConfirmHint: "మీ ఫోన్ నంబర్‌ను నిర్ధారించడానికి మేము కోడ్ పంపుతాము.",
    serviceMessagesHint: "మేము అప్పుడప్పుడు సేవా సందేశాలు పంపవచ్చు.",
    next: "తదుపరి",
    send: "పంపు",
    enterSecurityCode: "భద్రతా కోడ్ నమోదు చేయండి",
    codeSentTo: "కోడ్ పంపబడింది",
    didntReceiveCode: "కోడ్ రాలేదా?",
    resendIn: "మళ్లీ పంపు",
    resendCode: "కోడ్ మళ్లీ పంపు",
    resendNow: "ఇప్పుడే మళ్లీ పంపు",
    clear: "తొలగించు",
    close: "మూసివేయి",
    invalidEmailFormat: "దయచేసి సరైన ఇమెయిల్ చిరునామా నమోదు చేయండి (ఉదా., name@domain.com)",
  },
  ta: {
    verifyEmailAddress: "மின்னஞ்சல் முகவரியை சரிபார்க்கவும்",
    verifyPhoneNumber: "தொலைபேசி எண்ணை சரிபார்க்கவும்",
    enterDetailsForOtp: "OTP பெற உங்கள் விவரங்களை உள்ளிடவும்",
    enterMobileForOtp: "OTP பெற உங்கள் மொபைல் எண்ணை உள்ளிடவும்",
    emailPlaceholder: "you@gmail.com",
    fullName: "முழு பெயர்",
    enter10DigitNumber: "10 இலக்க எண்ணை உள்ளிடவும்",
    emailConfirmHint: "உங்கள் மின்னஞ்சல் முகவரியை உறுதிப்படுத்த குறியீட்டை அனுப்புவோம்.",
    phoneConfirmHint: "உங்கள் தொலைபேசி எண்ணை உறுதிப்படுத்த குறியீட்டை அனுப்புவோம்.",
    serviceMessagesHint: "எங்களால் அவ்வப்போது சேவை சார்ந்த செய்திகள் அனுப்பப்படலாம்.",
    next: "அடுத்து",
    send: "அனுப்பு",
    enterSecurityCode: "பாதுகாப்புக் குறியீட்டை உள்ளிடவும்",
    codeSentTo: "குறியீடு அனுப்பப்பட்டது",
    didntReceiveCode: "குறியீடு வரவில்லையா?",
    resendIn: "மீண்டும் அனுப்பு",
    resendCode: "குறியீட்டை மீண்டும் அனுப்பு",
    resendNow: "இப்போது மீண்டும் அனுப்பு",
    clear: "அழி",
    close: "மூடு",
    invalidEmailFormat: "சரியான மின்னஞ்சல் முகவரியை உள்ளிடவும் (எ.கா., name@domain.com)",
  },
  mr: {
    verifyEmailAddress: "ईमेल पत्ता सत्यापित करा",
    verifyPhoneNumber: "फोन नंबर सत्यापित करा",
    enterDetailsForOtp: "OTP मिळवण्यासाठी तुमचे तपशील प्रविष्ट करा",
    enterMobileForOtp: "OTP मिळवण्यासाठी तुमचा मोबाइल नंबर प्रविष्ट करा",
    emailPlaceholder: "you@gmail.com",
    fullName: "पूर्ण नाव",
    enter10DigitNumber: "10 अंकी नंबर प्रविष्ट करा",
    emailConfirmHint: "आम्ही तुमच्या ईमेल पत्त्याची पुष्टी करण्यासाठी कोड पाठवू.",
    phoneConfirmHint: "आम्ही तुमच्या फोन नंबरची पुष्टी करण्यासाठी कोड पाठवू.",
    serviceMessagesHint: "आम्ही कधीकधी सेवा संबंधित संदेश पाठवू शकतो.",
    next: "पुढे",
    send: "पाठवा",
    enterSecurityCode: "सुरक्षा कोड प्रविष्ट करा",
    codeSentTo: "कोड पाठवला",
    didntReceiveCode: "कोड मिळाला नाही?",
    resendIn: "पुन्हा पाठवा",
    resendCode: "कोड पुन्हा पाठवा",
    resendNow: "आत्ता पुन्हा पाठवा",
    clear: "साफ करा",
    close: "बंद करा",
    invalidEmailFormat: "कृपया वैध ईमेल पत्ता प्रविष्ट करा (उदा., name@domain.com)",
  },
  bn: {
    verifyEmailAddress: "ইমেইল ঠিকানা যাচাই করুন",
    verifyPhoneNumber: "ফোন নম্বর যাচাই করুন",
    enterDetailsForOtp: "OTP পেতে আপনার বিবরণ লিখুন",
    enterMobileForOtp: "OTP পেতে আপনার মোবাইল নম্বর লিখুন",
    emailPlaceholder: "you@gmail.com",
    fullName: "পুরো নাম",
    enter10DigitNumber: "১০ সংখ্যার নম্বর লিখুন",
    emailConfirmHint: "আপনার ইমেইল ঠিকানা নিশ্চিত করতে আমরা একটি কোড পাঠাব।",
    phoneConfirmHint: "আপনার ফোন নম্বর নিশ্চিত করতে আমরা একটি কোড পাঠাব।",
    serviceMessagesHint: "আমরা মাঝে মাঝে সেবা-সংক্রান্ত বার্তা পাঠাতে পারি।",
    next: "পরবর্তী",
    send: "পাঠান",
    enterSecurityCode: "নিরাপত্তা কোড লিখুন",
    codeSentTo: "কোড পাঠানো হয়েছে",
    didntReceiveCode: "কোড পাননি?",
    resendIn: "আবার পাঠান",
    resendCode: "কোড আবার পাঠান",
    resendNow: "এখনই আবার পাঠান",
    clear: "মুছুন",
    close: "বন্ধ করুন",
    invalidEmailFormat: "একটি বৈধ ইমেইল ঠিকানা লিখুন (যেমন, name@domain.com)",
  },
  kn: {
    verifyEmailAddress: "ಇಮೇಲ್ ವಿಳಾಸವನ್ನು ಪರಿಶೀಲಿಸಿ",
    verifyPhoneNumber: "ಫೋನ್ ಸಂಖ್ಯೆಯನ್ನು ಪರಿಶೀಲಿಸಿ",
    enterDetailsForOtp: "OTP ಪಡೆಯಲು ನಿಮ್ಮ ವಿವರಗಳನ್ನು ನಮೂದಿಸಿ",
    enterMobileForOtp: "OTP ಪಡೆಯಲು ನಿಮ್ಮ ಮೊಬೈಲ್ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ",
    emailPlaceholder: "you@gmail.com",
    fullName: "ಪೂರ್ಣ ಹೆಸರು",
    enter10DigitNumber: "10 ಅಂಕಿಯ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ",
    emailConfirmHint: "ನಿಮ್ಮ ಇಮೇಲ್ ವಿಳಾಸವನ್ನು ದೃಢೀಕರಿಸಲು ನಾವು ಕೋಡ್ ಕಳುಹಿಸುತ್ತೇವೆ.",
    phoneConfirmHint: "ನಿಮ್ಮ ಫೋನ್ ಸಂಖ್ಯೆಯನ್ನು ದೃಢೀಕರಿಸಲು ನಾವು ಕೋಡ್ ಕಳುಹಿಸುತ್ತೇವೆ.",
    serviceMessagesHint: "ನಾವು ಅಪ್ಪಾಗಾಗಿ ಸೇವಾ ಸಂದೇಶಗಳನ್ನು ಕಳುಹಿಸಬಹುದು.",
    clear: "ತೆರವುಗೊಳಿಸಿ",
    close: "ಮುಚ್ಚಿ",
    next: "ಮುಂದೆ",
    send: "ಕಳುಹಿಸಿ",
    enterSecurityCode: "ಭದ್ರತಾ ಕೋಡ್ ನಮೂದಿಸಿ",
    codeSentTo: "ಕೋಡ್ ಕಳುಹಿಸಲಾಗಿದೆ",
    didntReceiveCode: "ಕೋಡ್ ಸಿಗಲಿಲ್ಲವೇ?",
    resendIn: "ಮತ್ತೆ ಕಳುಹಿಸಿ",
    resendCode: "ಕೋಡ್ ಮತ್ತೆ ಕಳುಹಿಸಿ",
    resendNow: "ಈಗಲೇ ಮತ್ತೆ ಕಳುಹಿಸಿ",
    invalidEmailFormat: "ದಯವಿಟ್ಟು ಮಾನ್ಯ ಇಮೇಲ್ ವಿಳಾಸವನ್ನು ನಮೂದಿಸಿ (ಉದಾ., name@domain.com)",
  },
};

export const applyAuthContactLocales = (translations) => {
  Object.entries(AUTH_CONTACT).forEach(([lang, authContact]) => {
    if (!translations[lang]) return;
    translations[lang].authContact = {
      ...translations[lang].authContact,
      ...authContact,
    };
  });
};
